import { Country } from "@eco/client"
import { useGraphQLSearch } from "hooks"
import { CountryQuery } from "queries/CountryQuery"

export const useCountryQuery = () => {
    return useGraphQLSearch<Array<Country>, CountryQuery, TResponse>(
        new CountryQuery(), 
        (res: TResponse): Array<Country> => res.country
    )
}

type TResponse = { country: Array<Country> }
